/**
 * 时间格式化
 * @param datetime Date | string | number | null，默认空值表示当前时间
 * @returns object：{ date, get, format, daysInMonth, weekday, unix }
 * @description date[Date]
 * @description get[function]：year(年)、month(月1-12)、day(日)、weekday(周日-0~周六-6)、hour(时)、hour-12(12小时制)、minute(分)、second(秒)、millisecond(毫秒)
 * @description format[function]：格式化，默认为YYYY-MM-DD HH:mm:ss，如：1999-01-02 03:04:05:006，YYYY-1999、YY-99、MM-01、M-1、DD-02、D-2、HH-03、H-3、mm-04、m-4、ss-05、s-5、S-006
 * @description daysInMonth[function]：当月有多少天
 * @description unix[function]：时间戳(10位)
 * @description getTime[function]：毫秒数
 */
export const formatTime = (datetime) => {
	let date = new Date();
	if (datetime) {
		if (datetime instanceof Date) {
			date = datetime;
		} else if (typeof datetime === 'number') {
			date = new Date(Number(datetime.toString().padEnd(13, '0')));
		} else if (typeof datetime === 'string') {
			// ios解析不出YYYY-MM这种格式
			if (datetime.length < 8) datetime = `${datetime}-01`;
			date = new Date(datetime.replace('T', ' ').replace(/-/g, '/'));
		}
	}
	const get = (value) => {
		switch (value) {
			case 'year':
				return date.getFullYear();
			case 'month':
				return date.getMonth() + 1;
			case 'day':
				return date.getDate();
			case 'weekday':
				return date.getDay();
			case 'hour':
				return date.getHours();
			case 'hour-12':
				return date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
			case 'minute':
				return date.getMinutes();
			case 'second':
				return date.getSeconds();
			case 'millisecond':
				return date.getMilliseconds();
		}
	}
	const format = (pattern = 'YYYY-MM-DD HH:mm:ss') => {
		const res = [];
		const list = pattern.match(/YY(YY)?|yy(yy)?|MM?|DD?|HH?|hh?|mm?|ss?|S|./g) || [];
		for (let i = 0; i < list.length; i++) {
			const value = list[i];
			switch (value) {
				case 'YYYY':
				case 'yyyy':
				case 'YY':
				case 'yy':
					res.push(value.length === 2 ? get('year').toString().substring(2, 4) : get('year').toString());
					break;
				case 'MM':
				case 'M':
					res.push(get('month').toString().padStart(value.length, '0'));
					break;
				case 'DD':
				case 'D':
					res.push(get('day').toString().padStart(value.length, '0'));
					break;
				case 'HH':
				case 'H':
					res.push(get('hour').toString().padStart(value.length, '0'));
					break;
				case 'hh':
				case 'h':
					res.push(get('hour-12').toString().padStart(value.length, '0'));
					break;
				case 'mm':
				case 'm':
					res.push(get('minute').toString().padStart(value.length, '0'));
					break;
				case 'ss':
				case 's':
					res.push(get('second').toString().padStart(value.length, '0'));
					break;
				case 'S':
					res.push(get('millisecond').toString());
					break;
				default:
					res.push(value);
			}
		}
		return res.join('');
	}
	const daysInMonth = () => {
		return new Date(get('year'), get('month'), 0).getDate();
	}
	const unix = () => {
		return Math.round(date.getTime() / 1000);
	}
	const getTime = () => {
		return date.getTime();
	}
	return {
		date,
		get,
		format,
		daysInMonth,
		unix,
		getTime
	}
}